export default __webpack_public_path__ + "static/media/SplashImageOptimized.38355d6b.webp";